module.exports = __webpack_public_path__ + "static/media/Selfie-T-03.6d867bcd.png";